import dynamic from 'next/dynamic';

const InsightsClientStoriesCarousel = dynamic(() => import('./InsightsClientStoriesCarousel'));

export { type InsightsClientStoriesCarouselProps } from './InsightsClientStoriesCarousel';
export default InsightsClientStoriesCarousel;
